<template>
    <div>
        <strong>期間</strong>
        <template v-if="model.limits_opened_at">
            {{ model.limits_opened_at | baseDatetimeFormatter }}
        </template>
        <template v-else>
            指定なし
        </template>
        〜
        <template v-if="model.limits_closed_at">
            {{ model.limits_closed_at | baseDatetimeFormatter }}
        </template>
        <template v-else>
            指定なし
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

